module.exports = __webpack_public_path__ + "img/img_005-75x75-2.c8ae3d9c.png";